@value topRowHeight: 56px;
@value threadListWidth: 300px;
@value leadSidebarWidth: 300px;
@value leadSidebarCollapsedWidth: 50px;

.top-row {
    display: flex;
    width: 100%;
    flex-shrink: 0;
    border-bottom: 1px solid var(--off-white-dk);
    height: topRowHeight;
    box-sizing: border-box;
    background-color: var(--white);
}

.top-row-left {
    width: threadListWidth;
    border-right: 1px solid var(--off-white-dk);
    display: flex;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;
}

.top-row-right {
    flex: 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    align-items: center;
    padding-right: 16px;
}

.content-container {
    flex: 1;
    min-width: 0;
    min-height: 0;
    width: 100%;
    display: flex;
}

.thread-list-container {
    box-sizing: border-box;
    border-right: 1px solid var(--off-white-dk);
    height: 100%;
    width: threadListWidth;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.thread-list-search {
    padding: 8px;
    border-bottom: 1px solid var(--off-white-dk);
}

.thread-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - threadListWidth);
}

.thread-container-sidebar-collapsed {
    width: calc(100% - threadListWidth - leadSidebarCollapsedWidth);
}

.thread-container-sidebar-open {
    width: calc(100% - threadListWidth - leadSidebarWidth);
}

/* Used to avoid double borders without causing horizontal scrolling */
.thread-list-item-wrapper > div:first-child {
    border-top: none;
    border-right: none;
}
